import React from 'react';
import bemCn from 'bem-cn';
import banner1Img from '../../assets/img/blog/blog-banner-1.jpg?sizes[]=600,sizes[]=900';
import { RouteFormatter } from '../../routes';
import ListingParkHours from '../../components/listings-park-hours';
import SeoLocalBusiness from '../../components/seo-local-business';
import ListingAmenities from '../../components/listing-amenities';
import ListingParkRules from '../../components/listings-park-rules';
import ListingLocation from '../../components/listing-location/index-ssr';
import BlurSignupModal from '../../components/modal-blur-signup';
import ListingReviews from '../../components/listing-reviews/public';
import ListingFencing from '../../components/listing-fencing';
import BlogTopSticky from '../../components/blog-top-nav/top-sticky';
import { FOLLOW_US } from '../../components/footer-new';
import SniffButton from '../../components/sniff-button';
import PictureSet from '../../components/picture-set';
import SharePage from '../../components/spot-share-button/share-page';
import RenderNearbySpots from './render-nearby-spots-ssr';
import RenderHeadDesktop from './render-head-desktop';
import RenderHeadMobile from './render-head-mobile';
import RenderRating from './render-rating';
import RenderPrice from './render-price';
import SvgHostSafety from 'src/assets/svg/SvgHostSafety.svg';
import SvgShare from 'src/assets/svg/SvgShare.svg';
import SvgPin from 'src/assets/svg/SvgPin.svg';
import './public-park.scss';

const useGetMapkitToken = require('../../services/hooks/useGetMapkitToken');

const b = bemCn('public-park-details');

const TriggerComp = () => (
    <SniffButton className="mt-3" color="secondary" size="lg">
        <SvgShare className="me-2" />
        Share this page
    </SniffButton>
);

const Banner1 = () => (
    <div className={b('banner-1')}>
        <PictureSet imgs={banner1Img} width={900} height={422} alt="Sniffspot Dog running on field" />
        <div className={b('banner-1_content')}>
            <p className="snif-p snif-semibold mb-1 pb-05">Get safe exercise for your dog by renting a private dog park near you</p>
            <p>
                <a href={RouteFormatter.listings({})}>
                    <SniffButton>Explore spots near me</SniffButton>
                </a>
            </p>
        </div>
    </div>
);

const PublicPark = ({
    SSR,
    spot,
    useRef,
    rating,
    sortBy,
    goToHost,
    favSpots,
    isMobile,
    useState,
    useEffect,
    serverSSR,
    setRating,
    listBread,
    handleBook,
    shareModal,
    publicPark,
    reviewsRef,
    changeSort,
    isBlurTest,
    userDetails,
    usePrevious,
    moreHandler,
    sortReviews,
    useCallback,
    useAddReply,
    useOnScreen,
    dataReviews,
    goToReviews,
    getProbTest,
    setIsBlurTest,
    useHandleUpvote,
    useGetShareLink,
    toggleShareModal,
    mobilePhotoCount,
    useGetSpotReviews,
    handleSwipeMobile,
    handleChangeStars,
    desktopPhotoCount,
    useMutateFavorites,
    getTestWithProbSSR,
    desktopPhotoGallery,
    setDesktopPhotoCount,
    handleSniffpassBadge,
    setMobilePhotoGallery,
    handleNextDesktopGallery,
    handleBackDesktopGallery,
    toggleDesktopPhotoGallery,
}) => {
    const { mapkitToken } = serverSSR ? {} : useGetMapkitToken.default();
    const [mobile, setMobile] = useState(SSR ? true : isMobile);

    useEffect(() => {
        setMobile(isMobile);
    }, []);

    return (
        <>
            <BlogTopSticky {...{ useStateSSR: useState }} />
            <SeoLocalBusiness spot={spot} withReviews={spot.reviews} />
            <div className="spot-view-page container">
                <div className="spot-detail-block">
                    <div className="head-container">
                        <div className="d-md-none">
                            <RenderHeadMobile
                                {...{
                                    spot,
                                    rating,
                                    goToHost,
                                    isMobile,
                                    useState,
                                    setRating,
                                    listBread,
                                    useEffect,
                                    serverSSR,
                                    handleBook,
                                    publicPark,
                                    goToReviews,
                                    getProbTest,
                                    userDetails,
                                    setIsBlurTest,
                                    mobilePhotoCount,
                                    handleChangeStars,
                                    handleSwipeMobile,
                                    getTestWithProbSSR,
                                    handleSniffpassBadge,
                                    setMobilePhotoGallery,
                                }}
                            />
                        </div>
                        <div className="d-none d-md-block">
                            <RenderHeadDesktop
                                {...{
                                    SSR,
                                    spot,
                                    rating,
                                    favSpots,
                                    goToHost,
                                    isMobile,
                                    useState,
                                    listBread,
                                    useEffect,
                                    setRating,
                                    serverSSR,
                                    publicPark,
                                    userDetails,
                                    goToReviews,
                                    useCallback,
                                    useGetShareLink,
                                    desktopPhotoCount,
                                    handleChangeStars,
                                    useMutateFavorites,
                                    desktopPhotoGallery,
                                    setDesktopPhotoCount,
                                    handleSniffpassBadge,
                                    handleNextDesktopGallery,
                                    handleBackDesktopGallery,
                                    toggleDesktopPhotoGallery,
                                }}
                            />
                        </div>
                    </div>
                    <ListingParkHours workHours={spot.workHours} />
                    <ListingFencing
                        isMobileSSR={isMobile}
                        useStateSSR={useState}
                        encls={spot.enclosureType}
                        fncHeight={spot.fenceHeight}
                        gaps={spot.gaps}
                        fencingType={spot.fencingType}
                        fencingDetail={spot.fencingDetail}
                        fencingPercentage={spot.fencingPercentage}
                    />
                    <ListingAmenities
                        userDetails={userDetails}
                        isMobileSSR={isMobile}
                        useEffectSSR={useEffect}
                        useStateSSR={useState}
                        dogsAmenities={spot.dogsAmenities}
                        essentialAmenities={spot.essentialAmenities}
                        peopleAmenities={spot.peopleAmenities}
                        venueAmenities={spot.venueAmenities}
                        serverSSR={serverSSR}
                        setIsBlurTest={setIsBlurTest}
                        isBlurTest={isBlurTest}
                        allAmenities={spot.allAmenities}
                        publicPark
                    />
                    <RenderPrice {...{ isMobile, spot, publicPark, SSR }} />
                    <ListingLocation
                        isMobileSSR={isMobile}
                        useStateSSR={useState}
                        latitude={spot.latitude}
                        longitude={spot.longitude}
                        dscrpt={spot.summary || spot.description}
                        address={spot.address}
                        city={spot.city}
                        state={spot.state}
                        distanceFrom={spot.distanceFrom}
                        venueAmenities={spot.venueAmenities}
                        mapkitToken={mapkitToken}
                    />
                    <ListingParkRules rules={spot.rules} />
                    <Banner1 />
                    <div ref={reviewsRef}>
                        <ListingReviews
                            SSR={SSR}
                            spot={spot}
                            host={spot.host}
                            isTop={spot.top}
                            spotId={spot.id}
                            rating={spot.rating}
                            reviews={spot.reviews}
                            isMobile={isMobile}
                            changeSort={changeSort}
                            moreHandler={moreHandler}
                            sortReviews={sortReviews}
                            reviewsCount={spot.reviewsCount}
                            useEffectSSR={useEffect}
                            useStateSSR={useState}
                            useRefSSR={useRef}
                            useAddReplySSR={useAddReply}
                            useDeleteReplySSR={useAddReply}
                            useHandleUpvoteSSR={useHandleUpvote}
                            useGetSpotReviewsSSR={useGetSpotReviews}
                            useOnScreenSSR={useOnScreen}
                            userDetails={userDetails}
                            dataReviews={dataReviews}
                            sortBy={sortBy}
                            serverSSR={serverSSR}
                            setIsBlurTest={setIsBlurTest}
                            isBlurTest={isBlurTest}
                        />
                    </div>
                    {!spot.isReviewed && (
                        <div className="pb-md-2">
                            <RenderRating {...{ handleChangeStars, rating, setRating }} />
                        </div>
                    )}
                    {(spot.website || spot.email || spot.phoneNumber) && (
                        <div className={b('small-details')}>
                            <h4 className="snif-p ">Contact information</h4>
                            {spot.website && (
                                <a href={`https://${spot.website}`} target="_blank" rel="noreferrer">
                                    <SvgHostSafety />
                                    Visit website
                                </a>
                            )}
                            {spot.email && (
                                <a href={`mail:${spot.email}`}>
                                    <SvgHostSafety />
                                    {spot.email}
                                </a>
                            )}
                            {spot.phoneNumber && (
                                <a href={`tel:${spot.phoneNumber}`}>
                                    <SvgHostSafety />
                                    {spot.phoneNumber}
                                </a>
                            )}
                        </div>
                    )}
                    {mobile && (
                        <div className="d-md-none">
                            <RenderNearbySpots publicPark {...{ spot, SSR, useEffect, useState, usePrevious }} />
                        </div>
                    )}
                </div>
                <div className="desktop-book-block public-park">
                    <h5 className="snif-m2 snif-semibold mb-2">About Sniffspot</h5>
                    <p className="snif-p mb-3">
                        Sniffspot is a community marketplace that enables anyone to rent land by-the-hour as a safe and private dog park.
                    </p>
                    <a href={RouteFormatter.listings({})}>
                        <SniffButton size="lg">Explore nearby spots</SniffButton>
                    </a>
                    <div className="b-bot my-5" />
                    <h5 className="snif-m2 snif-semibold mb-2">Follow us</h5>
                    <p className="snif-s2 text-deep mb-3">Find Sniffspot on your favorite social media</p>
                    <div className="d-flex">
                        {FOLLOW_US.map((v, i) => (
                            <a key={i} href={v.link} target="_blank" rel="noopener noreferrer">
                                <PictureSet className="me-2" imgs={v.img} alt={v.alt} width={48} height={48} />
                            </a>
                        ))}
                    </div>
                    <SharePage shareBlog {...{ title: 'Share this page!', TriggerComp, shareModal, toggleShareModal }} />
                    <div className="b-bot mt-5" />
                </div>
            </div>
            {!mobile && (
                <div className="d-none d-md-block">
                    <RenderNearbySpots publicPark {...{ spot, SSR, useEffect, useState, usePrevious }} />
                </div>
            )}
            <div className={b('other-cities')}>
                <h2 className="snif-m1 snif-semibold mt-4 mb-3">Check out public and private dog parks in nearby cities</h2>
                <div className={b('other-cities_cont')}>
                    {spot.nearbyCities.map((c, i) => (
                        <a key={i} href={RouteFormatter.listings({ first: c.url })} className={b('other-city')}>
                            <SvgPin />
                            {c.name}
                        </a>
                    ))}
                </div>
            </div>
            <div className="d-md-none spot-view-margin" />
            <BlurSignupModal
                {...{
                    isBlurTest,
                    setIsBlurTest,
                    isMobile,
                    useStateSSR: useState,
                }}
                spotDetail
            />
        </>
    );
};

export default PublicPark;
